import { IVasRuleInitialState } from "../../../types/master/vasRuleInterface";
import { VasRuleActionTypes, VasRuleActions } from "../../actionTypes/master/vasRuleActionTypes";

const initialState: IVasRuleInitialState = {
  vasRuleList: [],
  vasRuleListPageCount: 0,
  vasRuleData: {
    id: 0,
    vas_type_id: 0,
    rate_basis_id: 0,
    vas_rate: "",
    min_amount: "",
    is_active: false,
    vas_type_data: null,
    rate_basis_data: null,
  },
};

export default function vasRuleReducer(state = initialState, action: VasRuleActionTypes): IVasRuleInitialState {
  switch (action.type) {
    case VasRuleActions.SET_VAS_RULE_LIST:
      return {
        ...state,
        vasRuleList: action.payload,
      };

    case VasRuleActions.SET_VAS_RULE_LIST_PAGE_COUNT:
      return {
        ...state,
        vasRuleListPageCount: action.payload,
      };

    case VasRuleActions.SET_VAS_RULE_DATA_BY_ID:
      return {
        ...state,
        vasRuleData: action.payload,
      };

    default:
      return state;
  }
}
